// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoom-meet-container {
    padding: 20px;
    background: #f8f9fc;
  }
  
  .title {
    color: #172639;
    font-weight: bold;
    margin-bottom: 15px;
  }
  
  /* TABLE */
  .zoom-meet-table {
    width: 100%;
    border-collapse: collapse;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  
  .zoom-meet-table thead {
    background-color: #172639;
    color: #fff;
  }
  
  .zoom-meet-table th,
  .zoom-meet-table td {
    padding: 12px;
    text-align: center;
    border-bottom: 1px solid #e5e7eb;
  }
  
  .zoom-meet-table tbody tr:nth-child(even) {
    background-color: #f4f6fa;
  }
  
  .zoom-meet-table tbody tr:hover {
    background-color: #e8edf3;
    transition: 0.2s;
  }
  
  .no-data {
    padding: 20px;
    color: #555;
  }
  
  /* START BUTTON */
  .start-btn {
    background-color: #172639;
    border: none;
    color: white;
    padding: 6px 14px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
  }
  
  .start-btn:hover {
    background-color: #0f1a26;
  }
  
  /* PAGINATION */
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  
  .pagination-btn {
    padding: 6px 12px;
    border: 1px solid #172639;
    background: white;
    color: #172639;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .pagination-btn:hover {
    background: #172639;
    color: white;
  }
  
  .pagination-btn.active {
    background: #172639;
    color: white;
  }
  
  .pagination-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/zoomMeets/ZoomMeetList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,UAAU;EACV;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;;IAEE,aAAa;IACb,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,eAAe;EACf;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB","sourcesContent":[".zoom-meet-container {\n    padding: 20px;\n    background: #f8f9fc;\n  }\n  \n  .title {\n    color: #172639;\n    font-weight: bold;\n    margin-bottom: 15px;\n  }\n  \n  /* TABLE */\n  .zoom-meet-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: #ffffff;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  }\n  \n  .zoom-meet-table thead {\n    background-color: #172639;\n    color: #fff;\n  }\n  \n  .zoom-meet-table th,\n  .zoom-meet-table td {\n    padding: 12px;\n    text-align: center;\n    border-bottom: 1px solid #e5e7eb;\n  }\n  \n  .zoom-meet-table tbody tr:nth-child(even) {\n    background-color: #f4f6fa;\n  }\n  \n  .zoom-meet-table tbody tr:hover {\n    background-color: #e8edf3;\n    transition: 0.2s;\n  }\n  \n  .no-data {\n    padding: 20px;\n    color: #555;\n  }\n  \n  /* START BUTTON */\n  .start-btn {\n    background-color: #172639;\n    border: none;\n    color: white;\n    padding: 6px 14px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 13px;\n  }\n  \n  .start-btn:hover {\n    background-color: #0f1a26;\n  }\n  \n  /* PAGINATION */\n  .pagination-container {\n    margin-top: 20px;\n    display: flex;\n    justify-content: center;\n    gap: 8px;\n  }\n  \n  .pagination-btn {\n    padding: 6px 12px;\n    border: 1px solid #172639;\n    background: white;\n    color: #172639;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .pagination-btn:hover {\n    background: #172639;\n    color: white;\n  }\n  \n  .pagination-btn.active {\n    background: #172639;\n    color: white;\n  }\n  \n  .pagination-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
